import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Tillsvidare = lazy(() => import("@/pages/elavtal/Tillsvidare"));

export const Route = createFileRoute("/elavtal/tillsvidare")({
  head: () => seoHead("/elavtal/tillsvidare", { description: "Ett tillsvidareavtal är det automatiska avtal du får om du inte aktivt valt elhandlare. Det är oftast det dyraste avtalet på marknaden." }),
  component: () => <Tillsvidare />,
});
